import Vue from "vue";
import Loading from "../lib/loading";

//Global Component
Vue.component("loading", Loading);
